/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compress_TitleInputs */



/**
* | output |
* | --- |
* | "Compress Text" |
*
* @param {Compress_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compress_title = /** @type {((inputs?: Compress_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compress_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compresser le Texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text komprimieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Comprimi testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сжать текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comprimir texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("压缩文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストを圧縮")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट को संपीड़ित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comprimir texto")
	return /** @type {LocalizedString} */ ("Compress Text")
});